import type { Socket } from "socket.io-client"

export interface IntradayPriceItem {
  price: string
  change_percent: string
}

export type PricesUpdatedPayload = Record<string, IntradayPriceItem>

export const PRICES_UPDATED_EVENT = "pricesUpdated"
const SUBSCRIPTION_EVENT = "pricesSubscription"
const SUBSCRIPTION_ADD_EVENT = "pricesSubscriptionAdd"
const SUBSCRIPTION_REMOVE_EVENT = "pricesSubscriptionRemove"
const UNSUBSCRIBE_EVENT = "pricesUnsubscribe"

export interface PricesSubscriptionPayload {
  modelProviderIds: string[]
  modelId: string
}

export interface SubscriptionRemovePayload {
  modelProviderIds: string[]
}

export function subscribeToPrices(
  socket: Socket,
  modelProviderIds: string[],
  modelId: string,
): void {
  socket.emit(SUBSCRIPTION_EVENT, {
    modelProviderIds,
    modelId,
  } satisfies PricesSubscriptionPayload)
}

export function addPriceSubscription(socket: Socket, modelProviderIds: string[], modelId: string): void {
  if (modelProviderIds.length === 0) {
    return
  }
  socket.emit(SUBSCRIPTION_ADD_EVENT, {
    modelProviderIds,
    modelId,
  } satisfies PricesSubscriptionPayload)
}

export function removePriceSubscription(socket: Socket, modelProviderIds: string[]): void {
  if (modelProviderIds.length === 0) return
  socket.emit(SUBSCRIPTION_REMOVE_EVENT, {
    modelProviderIds,
  } satisfies SubscriptionRemovePayload)
}

export function unsubscribeFromPrices(
  socket: Socket,
): void {
  socket.emit(UNSUBSCRIBE_EVENT)
}
